import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { trackGeneralEvent } from '@scentregroup/shared/helpers/analytics-utils/track-event';
export function trackClickStoreDetailsLink(e, store) {
  const target = e.currentTarget;
  const link = target.getElementsByTagName('a')[0];
  if (!link) {
    return;
  }
  trackGeneralEvent('Store Selected', undefined, undefined, undefined, {
    properties: _objectSpread(_objectSpread({
      ['content_id']: store.id,
      ['content_source']: "contentful_".concat(store.spaceId),
      ['content_type']: 'Store',
      ['content_title']: store.title,
      ['store_slug']: store.slug,
      ['centre_slug']: store.centreSlug
    }, link.innerText ? {
      ['link_text']: link.innerText
    } : null), {}, {
      ['link_url']: link.href,
      ['context']: 'Centre Store Directory'
    })
  });
}